// i18n area 'vms' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.lt-LT.meta.json.
import type { enUS } from './vms'

export const ltLT: typeof enUS = {
  vms: {
    spof: {
      title: 'Nepriklausomybė nuo mazgo',
      single: 'Vienintelis gedimo taškas',
      alternativesNow: 'Alternatyvos dabar',
      structural: 'Pagal konstrukciją',
      binding: 'Ribojanti sąlyga',
      movableNow: 'Migracija galima dabar',
    },
    title: 'Virtualiosios mašinos',
    migratingChip: 'Vyksta migracija',
    templateChip: 'Template',
    expendableTooltip: 'Degradavusiame klasteryje ji viena pirmųjų sustabdoma ir po mazgo praradimo gali nebepasileisti.',
    expendableHaTooltip: 'Visada paleidžiama iš naujo, kol klasteris sveikas; degradavusiame klasteryje apsaugotos VM eina pirmos — ji gali būti sustabdyta arba likti išjungta, kol klasteris vėl bus pilnas, tada grįžta pati.',
    viewDetails: 'Peržiūrėti detales',
    profileLegacy: 'Kita OS',
    hugePagesNone: 'Nėra — įprasta atmintis',
    hugePages2M: '2 MiB puslapiai',
    hugePages1G: '1 GiB puslapiai',
    searchPlaceholder: 'Ieškoti pagal pavadinimą',
    name: 'Pavadinimas',

    // VIENA terminologija (#94a): fazė visur vadinama „Fazė“ — senasis raktas
    // „state“ mirė kartu su sąrašo nugludinimu.
    vcpus: 'vCPU',
    memory: 'Atmintis',
    ipAddresses: 'IP adresai',
    noIp: 'IP nėra',
    authorityNode: 'Authority',
    authorityNextStart: 'priskiriama kito paleidimo metu',
    scope: 'Scope',
    empty: 'Virtualiųjų mašinų nėra',
    loadError: 'Nepavyko įkelti virtualiųjų mašinų — ar TVirt backend pasiekiamas?',
    filterOverlay: 'overlay tinklas',
    filterDisk: 'diskas',
    filterImage: 'atvaizdis',
    filteredBy: 'Filtruota pagal {kind}',
    filterPhase: 'Fazė',
    filterProtection: 'Apsauga',
    filterAll: 'Visos',
    filterScopePlaceholder: 'Filtruoti pagal scope',
    filtersToggle: 'Filtrai',
    scopeTree: {
      title: 'Scope',
      all: 'Visas klasteris',
      noChildren: 'Čia nėra antrinių scope',
      recursive: 'Įtraukti žemesnio lygio',
      collapse: 'Suskleisti scope skydelį',
      up: 'Kilti lygiu aukščiau',
      countTooltip: '{direct} VM šiame scope · {total} įskaitant žemesnio lygio'
    },

    // Dviejų žingsnių ISO parinkiklis (#85): pirma katalogas, paskui jo ISO.
    isoPicker: {
      catalog: 'Katalogas',
      unknownCatalog: 'Už matomų katalogų ribų',
      noIsos: 'Šiame kataloge nėra parengtų ISO atvaizdžių'
    },
    actionsHeader: 'Veiksmai',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Aparatinė įranga',
      tags: 'Žymos',
      age: 'Amžius',
      disk: 'diskas',
      disks: 'diskai',
      empty: 'Template nėra — pažymėkite išjungtą VM kaip template arba klonuokite VM kaip template.',
      clone: 'Klonuoti / diegti',
      editTags: 'Redaguoti žymas',

      // Round K3 (#64): eksportuoja template kaip katalogo .tvtpl failą.
      exportAction: 'Eksportuoti į katalogą (.tvtpl)',
      exportTitle: 'Eksportuoti į katalogą',
      exportSubmit: 'Eksportuoti',
      exportError: 'Eksportuoti nepavyko',
      exportHint: 'Template supakuojamas į .tvtpl archyvą (aparatinės įrangos manifestas ir kiekvienas diskas, suplokštintas į qcow2) kaip naujas VM Template failas pasirinktame kataloge. NIC, CD/DVD laikmenos ir cloud-init nekeliauja — formato specifikacija išvardija kiekvieną sąmoningą praleidimą.',
      exportName: 'Failo pavadinimas',
      exportNameHint: 'Tuščia = <template>-export-<n>',
      exportStorageDefault: 'Template metaduomenų storage',

      // Importas iš katalogo (Luca 2026-08-03): įėjimas kortelės Template
      // įrankių juostoje — K3/K4 backend padengia visus vm-template formatus,
      // renkamasi FAILAS (formatas keliauja tik skaitymui).
      importAction: 'Importuoti iš katalogo',
      importTitle: 'Importuoti iš katalogo',
      importHint: 'Parengtas VM Template failas iš pasirinkto katalogo tampa inventoriaus template: failo formatas (tvtpl, ova, ovf ar plikas qcow2) pats nusprendžia, kaip importuojama — jūs renkatės tik failą.',
      importFile: 'Katalogo failas',
      importFileHint: 'Importuojami tik parengti failai — įpusėjęs įkėlimas neimportuojamas',
      importNoFiles: 'Šiame kataloge nėra parengtų VM Template failų — pirma įkelkite arba eksportuokite vieną'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy suderinamumas',
      quickDeployNone: 'Nedeklaruota',
      quickDeployHint: 'Deklaruokite tik jei golden atvaizde yra cloud-init (Linux) arba cloudbase-init po sysprep /generalize (Windows): platforma pasitiki deklaracija ir niekada nežiūri į svečio vidų.',
      notFound: 'Template nerastas',
      frozen: 'Aparatinės įrangos konfigūracija užšaldyta: norėdami ją keisti, grąžinkite template į VM. Pavadinimas, pastabos ir žymos lieka redaguojami.',
      storage: 'Storage',
      size: 'Dydis',
      configTitle: 'Konfigūracija (užšaldyta)',
      usbClasses: 'Reikalingos USB klasės',
      gpuClasses: 'Reikalingos GPU klasės'
    },
    sharedDisksTab: {
      title: 'Bendrinami diskai',
      sharing: 'Bendrinimas',
      sharingNone: 'Vienas prijungimas',
      sharingMultiwriter: 'Bendrinamas rašymas (multiwriter)',
      sharingReadonly: 'Bendrinamas tik skaitymas',
      usedBy: 'Naudoja',
      attachedTo: 'Prijungtas prie',
      notAttached: 'Neprijungtas prie jokios VM',
      changeSharing: 'Keisti bendrinimo režimą',
      changeSharingTitle: 'Bendrinimo režimas',
      changeSharingLocked: 'Režimas keičiamas tik kol disko nenaudoja jokia VM',
      sharingChanged: 'Bendrinimo režimas atnaujintas.',
      lun: 'Visas LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serijos numeris',
      antiAffinityWarning: 'Du ar daugiau narių veikia tame pačiame mazge be anti-afiniteto taisyklės: vieno mazgo gedimas nuvers visus',
      antiAffinityCreate: 'Sukurti taisyklę',
      createSourceLun: 'Perimti visą target LUN',
      createLunNumber: 'LUN numeris (namespace id NVMe)',
      createLunHint: 'Niekas neskiriama: dydis nuskaitomas iš įrenginio perimant',
      noPr: 'Šioje laidoje nėra SCSI-3 persistent reservations: Windows Failover Cluster su klasikiniu bendrinamu disku nevaliduotas; klasteriai, kurie koordinuojasi tinklu (GFS2/OCFS2, RHEL HA, shared-disk duomenų bazės) — taip'
    },
    unusedDisksTab: {
      title: 'Nenaudojami diskai',
      attach: 'Prijungti prie VM',
      attachTitle: 'Prijungti prie VM',
      vm: 'Virtualioji mašina',
      noVms: 'Nėra nė vienos galimos VM',
      noSlots: 'Šioje VM nėra laisvo slot',

      // Atskiro disko kūrimas (#87): grįžo iš pensijon išleisto Inventoriaus,
      // dabar su AIŠKIU scope lauku (nėra VM, iš kurios būtų paveldima).
      create: 'Kurti diską',
      createTitle: 'Kurti diską',
      createSourceBlank: 'Tuščias diskas',
      createSourceImage: 'Iš katalogo atvaizdžio',
      createImage: 'Atvaizdis',
      createImageEmpty: 'Matomuose kataloguose nėra parengto VM šablono atvaizdžio',
      createSizeFromImageHint: 'Užpildyta atvaizdžio virtualiu dydžiu — gali tik didėti',

      // #107 (DESTRUKTYVU, ratifikuota): qcow2 → vm-template katalogo failas
      // tame pačiame storage, nenukopijuojamas nė vienas baitas — diskas
      // nustoja egzistuoti.
      convert: 'Konvertuoti į VM template…',
      convertOnlyQcow2: 'Konvertuojami tik qcow2 diskai — raw nėra registruojamas template formatas',
      convertTitle: 'Konvertuoti į VM template',
      convertSubmit: 'Konvertuoti (diskas sunaikinamas)',
      convertError: 'Nepavyko pradėti konvertavimo',
      convertWarning: 'DESTRUKTYVU: diskas tampa VM template failu pasirinktame kataloge — tas pats storage, nenukopijuojamas nė vienas baitas — ir NUSTOJA EGZISTUOTI kaip diskas. Atgal nebegrįšite kitaip, kaip iš template sukurdami naują diską.',
      convertNameHint: 'Katalogo failo pavadinimas — numatytasis yra disko pavadinimas',
      convertConfirm: 'Supratau: diskas bus sunaikintas',
      convertStarted: 'Konvertavimas pradėtas — template atsiras kataloge, kai task bus baigtas.',
      storageLockHint: 'Storage keičiamas tik veiksmu Perkelti',
      source: 'Kilmė',
      sourceClone: 'Kito disko klonas',
      sourceCloneLinked: 'Kito disko linked clone',
      sourceImage: 'Sukurtas iš atvaizdžio',
      sourceBlank: 'Sukurtas tuščias',
      allocated: 'Užimta / virtualus dydis',
      observedAt: 'Stebėta',
      snapshots: 'Snapshot',
      snapshotsEmpty: 'Snapshot nėra'
    },
    phase: {
      defined: 'Niekada neįjungta',
      starting: 'Paleidžiama',
      running: 'Veikia',
      stopping: 'Stabdoma',
      stopped: 'Išjungta',
      paused: 'Pristabdyta',
      failed: 'Klaidos būsenoje',
      deleting: 'Trinama'
    },
    stopCause: {
      'api': 'Sustabdyta TVirt (veiksmu arba per API)',
      'guest-shutdown': 'Išjungimą pradėjo svečio operacinė sistema',
      'crash': 'Svečio strigtis',
      'qemu-exit': 'QEMU procesas netikėtai nutrūko',
      'host-reboot': 'Mazgas buvo paleistas iš naujo',
      'migrated': 'Migruota į kitą mazgą',
      'fenced': 'Nutraukta HA fencing (mazgas sugrįžo)'
    },
    detail: {
      notFound: 'Virtualioji mašina nerasta',
      details: 'Detalės',
      id: 'ID',
      scope: 'Scope',
      profile: 'Aparatinės įrangos profilis',
      firmware: 'Firmware',
      firmwareFile: 'UEFI firmware versija',
      firmwareUpdate: 'Yra atnaujinimas',
      firmwareUpdateHint: 'Platforma tiekia naujesnį UEFI firmware. Atnaujinimas niekada nevyksta automatiškai: jis taikomas išjungus VM, kai tu taip nusprendi.',
      arch: 'Architektūra',
      node: 'Mazgas',
      bootOrder: 'Įkrovos tvarka',
      agent: 'Agent būsena',
      agentConnected: 'Prisijungęs',
      agentNotConnected: 'Neprisijungęs',
      protected: 'Apsaugota',
      linkedClones: 'Susieti klonai',
      restartPolicy: 'Paleidimo iš naujo politika',
      preferredNode: 'Pageidaujamas mazgas',
      noPreference: 'Jokio pageidavimo (automatinis placement)',
      preferNodes: 'Pageidaujamos mazgo žymos',
      requireNodes: 'Privalomos mazgo žymos',
      noPlacementTags: 'Nėra',
      placementTag: 'Žyma',
      placementValue: 'Reikšmė',
      placementAddTag: 'Pridėti žymą',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA paleidimai iš naujo',
      proximityHaGaveUp: 'strigčių ciklas — HA pasidavė',
      failoverProtection: 'Apsauga degradavusiame klasteryje',
      protectionProtected: 'Apsaugota',
      protectionExpendable: 'Paaukojama degradavus',
      protectionInherit: 'Paveldėti',
      lastStop: 'Paskutinis sustabdymas',
      yes: 'Taip',
      no: 'Ne',
      tabOverview: 'Apžvalga',
      tabSnapshots: 'Snapshot',
      tabBackups: 'Kopijos',
      hardware: 'Aparatinė įranga',
      name: 'Pavadinimas',
      hwSystem: 'Sistema',
      hwCpu: 'CPU',
      hwMemory: 'Atmintis',
      hwBoot: 'Įkrova',
      hwIdentity: 'Tapatybė',
      hwCluster: 'Klasteris ir agent',
      cpuTopology: 'CPU topologija',
      cpuModel: 'CPU modelis',
      cpuLimit: 'CPU riba',
      cpuWeight: 'CPU svoris',
      cpuNested: "Įdėtoji virtualizacija",
      cpuNestedHint: "Atveria svečiui vmx/svm (tik su CPU modeliu host). Veikiančioje VM pakeitimas įsigalioja per kitą power cycle (PendingRestart); išdėstymas leidžia tik mazgus su įjungtu nested.",
      unlimited: 'Neribota',
      memory: 'Atmintis',
      balloon: 'Balloon',
      hugePages: 'Milžiniški puslapiai',
      hugePagesTradeoff: 'Mažiau adresų vertimo darbo ir atmintis, kuri niekada nepatenka į diską; mainais rezervacija lieka pririšta prie mazgo, kol VM veikia, atmintis nebededuplikuojama, o paleidimas nepavyksta, jei mazge per mažai laisvų puslapių.',
      disks: 'Diskai',
      cdroms: 'CD/DVD įrenginiai',
      nics: 'Tinklo sąsajos',
      slot: 'Slot',
      disk: 'Diskas',
      encrypted: 'Užšifruotas',
      image: 'Atvaizdis',
      emptyDrive: 'Tuščias įrenginys',
      emptyOption: '(tuščia)',
      network: 'Tinklas',
      mac: 'MAC',
      connected: 'Prijungta',
      unplugged: 'Atjungta',
      noDevices: 'Nėra',
      screenshot: 'Ekrano nuotrauka',
      capturedAt: 'Padaryta',
      noCapture: 'Nuotraukų nėra',
      snapshotName: 'Pavadinimas',
      snapshotCreated: 'Sukurta',
      snapshotMemory: 'Įtraukta atmintis',
      noSnapshots: 'Snapshot nėra',
      pendingRestart: 'Laukiantys pakeitimai: jie bus pritaikyti per kitą maitinimo ciklą.',
      applied: 'pritaikyta',
      appliedHint: 'VM veikia su šia reikšme — sukonfigūruotoji bus pritaikyta per kitą maitinimo ciklą.',
      actionError: 'Veiksmas nepavyko',
      actionStillRunning: 'Veiksmas vis dar vykdomas — rezultatas dar nežinomas',
      tabConsole: 'Konsolė',
      consoleConnect: 'Prisijungti',
      consoleDisconnect: 'Atsijungti',
      consoleConnecting: 'Jungiamasi…',
      consoleReconnecting: 'Jungiamasi…',
      consoleUnavailable: 'Konsolė pasiekiama, kai VM veikia arba yra pristabdyta.',
      consoleError: 'Prisijungti prie konsolės nepavyko',
      consoleTaken: 'Konsolės seansą užėmė {user}',
      consoleReconnect: 'Jungtis iš naujo',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Laikyti nuspaustą {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Atverti visame ekrane naujoje kortelėje',
      consoleLoadFailed: 'VM nerasta arba nepakanka teisių',
      consoleClose: 'Užverti',
      tabStats: 'Statistika',
      tabTasks: 'Task',
      tabLogs: 'Žurnalas',
      statsCpu: 'CPU',
      statsMemory: 'Atmintis',
      statsDisk: 'Disko I/O',
      statsRange: 'Intervalas',
      statsNoData: 'Šiame intervale duomenų nėra — statistika renkama, kai VM veikia.',
      statsError: 'Nepavyko įkelti statistikos',
      cpuUsage: 'Naudojimas',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Naudojama',
      memGuestAvailable: 'Laisva (svečias)',
      schema: 'Schema',
      consoleProtocol: 'Konsolė',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Metaduomenų storage',
      startupOnBoot: 'Paleidimas per įkrovą',
      startupOrder: 'Paleidimo eiliškumas',
      startupDelay: 'Paleidimo delsa',
      seconds: 's',
      enabled: 'Įjungta',
      disabled: 'Išjungta'
    },
    actionsAvailable: 'Galimi veiksmai',
    actions: {
      start: 'Paleisti',
      stop: 'Stabdyti',
      pause: 'Pristabdyti',
      resume: 'Tęsti',
      reset: 'Perkrauti',
      migrate: 'Migruoti',
      clone: 'Klonuoti',
      moveStorage: 'Perkelti į storage…',
      moveScope: 'Perkelti į scope…',
      openConsole: 'Atverti konsolę',
      forceStop: 'Priverstinai išjungti',
      markTemplate: 'Žymėti kaip template',
      unmarkTemplate: 'Grąžinti į VM',
      error: 'Nepavyko įvykdyti veiksmo'
    },
    cordon: {
      confirmTitle: 'Mazgas yra techninėje priežiūroje',
      confirmHint:
        'Kordono negalima nuleisti, kol klasterio store neveikia. Patvirtindami pareiškiate, kad tai žinote: VM ten vis tiek įsijungs, o sutikimas liks užfiksuotas užduotyje.',
      confirm: 'Vis tiek įjungti'
    },
    markTemplate: {
      confirmTitle: 'Žymėti {name} kaip template?',
      confirmBody: 'Konfigūracija užšaldoma ir VM nebegalės įsijungti — tik klonuotis arba grįžti į VM. Pavadinimas, pastabos ir žymos lieka redaguojami.',
      confirm: 'Žymėti kaip template',
      moved: '{name} dabar yra template — perkelta į kortelę Template.'
    },
    unmarkTemplate: {
      confirmTitle: 'Grąžinti {name} į VM?',
      confirmBody: 'Template vėl tampa įprasta VM: redaguojama ir paleidžiama (kitas paleidimas pastatys ją mazge).',
      confirm: 'Grąžinti į VM',
      moved: '{name} vėl yra virtualioji mašina — perkelta į kortelę Virtualiosios mašinos.'
    },

    // Round #123: nuoroda į mazgą pagal ŽYMĄ (selektorius #106) paleidimo ir
    // migravimo dialoguose — su nustatytos aibės peržiūra.
    nodeByTag: {
      label: 'Pagal mazgo žymą',
      hint: 'žyma=reikšmė, atskirti kableliais (jungiami AND): sprendiklis renkasi iš atitinkančių mazgų',
      invalid: 'Netinkamas formatas — naudokite žyma=reikšmė, atskirtus kableliais',
      resolved: 'Atitinkantys nariai: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migruoti',
      target: 'Paskirties mazgas',
      auto: 'Automatiškai (Proximity)',
      hint: 'VM persikelia be maitinimo ciklo. Kiekvienas jos liečiamas storage turi būti bendrinamas; pristabdyta VM migruoja pristabdyta.',
      error: 'Migracija buvo atmesta'
    },
    moveStorage: {
      title: 'Perkelti į storage',
      submit: 'Perkelti',
      target: 'Paskirties storage',
      noTargets: 'Nė vienas storage nepriima diskų',
      hint: 'Visi išjungtos VM diskai po vieną keliauja į pasirinktą storage išsaugodami savo id — tie, kurie jau yra paskirties vietoje, praleidžiami. Eigą matysite task puslapyje.',
      error: 'Perkėlimas buvo atmestas'
    },
    moveScope: {
      title: 'Perkelti į scope',
      submit: 'Perkelti',
      target: 'Paskirties scope',
      hint: 'VM scope pasikeičia iškart — id ir diskai lieka, jai priklausantys diskai keliauja kartu, o ji gali likti įjungta. Šiandien ji gyvena {scope}. Kartu su scope keičiasi ir tie, kas ją mato.',
      error: 'Scope keitimas buvo atmestas'
    },
    start: {
      title: 'Paleisti VM',
      submit: 'Paleisti',
      target: 'Paskirties mazgas',
      auto: 'Automatiškai (rekomenduojama)',
      recommended: 'rekomenduojama',
      hint: 'Pasirinkite paskirties mazgą arba leiskite Proximity nuspręsti tarp tinkamų kandidatų. Mazgai, kurie jos priimti negali, yra neaktyvūs ir nurodo priežastį.',
      error: 'Nepavyko paleisti VM'
    },
    console: {
      media: 'CD/DVD įrenginiai',
      mediaGuestToolsHint: 'Jame yra TVirt Guest Tools — iš čia galite jas išstumti arba pašalinti įrenginį',
      slotOpsDeferred: 'Šiame profilyje įrenginių pridėjimas ir šalinimas pritaikomi per kitą maitinimo ciklą (laikmenų keitimas veikia iškart).',
      mountGuestTools: 'Prijungti TVirt Guest Tools',
      ejectGuestTools: 'Išstumti TVirt Guest Tools',
      bootOrder: 'Įkrovos tvarka',
      bootOrderHint: 'Nauja tvarka įrašoma iškart ir pritaikoma per kitą maitinimo ciklą — konsolės seansas lieka prijungtas.'
    },
    snapshots: {
      create: 'Kurti snapshot',
      createTitle: 'Kurti snapshot',
      createSubmit: 'Kurti',
      name: 'Pavadinimas',
      nameHint: 'Raidės, skaitmenys, taškas, brūkšnelis, pabraukimas.',
      consistencyHint: 'Nuoseklumas užtikrinamas automatiškai: svečio agent užšaldo failų sistemas, kai atsiliepia; kitu atveju VM akimirkai pristabdoma aplink snapshot.',
      memory: 'Įtraukti atmintį',
      memoryHint: 'Įrašoma gyva RAM: atkūrimas pratęsia veikiančią VM. Reikia, kad visi diskai būtų qcow2.',
      currentChip: 'Jūs čia',
      revert: 'Atkurti',
      revertTitle: 'Atkurti {name}?',
      revertBody: 'Diskai grįžta į snapshot būseną; viskas, kas įvyko po jo, prarandama. Snapshot tik su diskais reikalauja sustabdytos VM.',
      delete: 'Ištrinti',
      deleteTitle: 'Ištrinti snapshot {name}?',
      deleteBody: 'Atkūrimo taškas dingsta; diskų turinys lieka nepaliestas.',
      deleteMergeHint: 'Jo delta suliejama į {children}: kiekvienas vėlesnis atkūrimo taškas lieka galiojantis.',
      deleteDuplication: 'Sutinku su dubliavimu',
      deleteDuplicationHint: 'Delta nukopijuojama į kiekvieną iš {count} skaitytojų (dukterinius snapshot ir, jei šis yra dabartinis, aktyvią galvą): užimta vieta gali augti, o ne mažėti.',
      error: 'Snapshot operacija buvo atmesta'
    },
    clone: {
      title: 'Klonuoti VM',
      submit: 'Klonuoti',
      name: 'Kopijos pavadinimas',
      storage: 'Paskirties diskų storage',
      sameStorage: 'Toks pat kaip šaltinio',
      full: 'Pilna kopija',
      fullHint: 'Nukopijuojamas kiekvienas baitas ir nutraukiamas ryšys su šaltinio diskais. Numatytoji yra linked clone: akimirksniu, bet prirakinta prie šaltinio (tik qcow2).',
      hint: 'Klonas išlaiko šaltinio konfigūraciją ir firmware; MAC adresai ir TPM tapatybė yra nauji.',
      markAs: 'Klono tipas',
      markAsInheritVm: 'Kaip šaltinis (VM)',
      markAsInheritTemplate: 'Kaip šaltinis (template)',
      markAsVm: 'Virtualioji mašina',
      markAsTemplate: 'Template',
      markAsHintVm: 'Pasirinkite Template, kad kopiją paaukštintumėte vienu žingsniu.',
      markAsHintTemplate: 'Pasirinkite Virtualioji mašina, kad iš šio template diegtumėte vienu žingsniu.',
      error: 'Klonavimas buvo atmestas'
    },
    bulk: {
      selected: 'pažymėta',
      deleteTitle: {
        one: 'Ištrinti {count} pažymėtą VM?',
        few: 'Ištrinti {count} pažymėtas VM?',
        many: 'Ištrinti {count} pažymėtos VM?',
        other: 'Ištrinti {count} pažymėtų VM?'
      },
      deleteBody: 'Kiekviena VM praeina tuos pačius sargus kaip ir trinama po vieną; atmetimai nurodomi kiekvienam elementui atskirai.',
      done: 'priimta',
      refused: 'atmesta'
    },
    delete: {
      button: 'Ištrinti',
      confirmTitle: 'Ištrinti {name}?',
      confirmBody: 'Virtualioji mašina ir jai priklausantys diskai bus ištrinti. Veiksmas negrįžtamas.',
      keepDisks: 'Palikti diskus',
      keepDisksHint: 'Kartu su VM sukurti diskai lieka savo storage kaip savarankiški diskai.',
      confirm: 'Ištrinti',
      cancel: 'Atšaukti',
      error: 'Ištrinti nepavyko',
      blockedPhase: 'Pirma sustabdykite VM',
      blockedProtected: 'VM apsaugota — pirma pašalinkite apsaugą',
      blockedDeleting: 'Trynimas jau vyksta'
    },
    logs: {
      title: 'Žurnalas',
      subtitle: 'Struktūruoti žurnalo kadrai iš task, kurie liečia šią VM',
      when: 'Kada',
      task: 'Task',
      level: 'Lygis',
      message: 'Pranešimas',
      empty: 'Žurnalo įrašų dar nėra',
      loadError: 'Nepavyko įkelti žurnalo — ar TVirt backend pasiekiamas?'
    },
    stop: {
      title: 'Stabdyti virtualiąją mašiną',
      modeGraceful: 'Sklandus išjungimas',
      modeGracefulHint: 'Svečio operacinės sistemos prašoma išsijungti natūraliai (ACPI); jei ji prašymo nepaiso, pasibaigus skirtajam laikui įvyksta priverstinis išjungimas.',
      modeForced: 'Priverstinis išjungimas',
      modeForcedHint: 'Maitinimas nutraukiamas iškart, tarsi ištrauktumėte kištuką.',
      timeout: 'Atsarginis skirtasis laikas (sekundėmis)',
      timeoutHint: 'Kiek laukiama svečio, kol išjungimas taps priverstinis'
    },

    // Kūrimo mygtuko meniu (Luca 2026-07-23): „Nuo nulio“ atveria vediklį,
    // kiti du punktai yra planų stub.
    createFromScratch: 'Nuo nulio',
    createFromTemplate: 'Iš template',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Vykdyti deploy',
      error: 'Deploy nepavyko',
      compatNote: 'QuickDeploy reikalauja su QuickDeploy suderinamo šablono: platforma pirmojo paleidimo metu pritaiko svečią (tinklas, domenas, aktyvavimas).',
      template: 'Šablonas',
      noTemplates: 'Nė vienas šablonas dar nedeklaruoja QuickDeploy suderinamumo — deklaruokite jį skirtuke Šablonai (Linux su cloud-init, Windows su cloudbase-init po sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Pagrindinio kompiuterio vardas',
      hostnameHint: 'Pagrindinio kompiuterio vardas arba FQDN; tuščia = VM vardas (Windows: ne daugiau kaip 15 simbolių)',
      ip: 'IP adresas',
      ipHint: 'Adresas ir prefiksas, pvz., 192.168.122.101/24; tuščia = DHCP',
      gateway: 'Šliuzas',
      dns: 'DNS serveriai',
      dnsHint: 'Iki trijų, atskirtų kableliais',
      count: 'Egzemplioriai',
      countHint: 'Daugiau nei vienas: pavadinti <vardas>-1…-N, tik DHCP',
      user: 'Naudotojas',
      userHint: 'Tuščia = numatytasis atvaizdo naudotojas (Linux) arba Administrator (Windows)',
      password: 'Slaptažodis',
      passwordHint: 'Įrašomas į sugeneruotą user-data, kurią platforma paskui paskelbia slapta: niekas jos daugiau neperskaito',
      sshKeys: 'Vieši SSH raktai',
      sshKeysHint: 'Po vieną eilutėje (ssh-ed25519 AAAA… komentaras)',
      productKey: 'Windows produkto raktas',
      kmsServer: 'KMS serveris',
      kmsHint: 'Adresas arba adresas:prievadas — reikia produkto rakto (KMS kliento rakto)',
      adDomain: 'Prijungti prie Active Directory domeno',
      adDomainHint: 'Tuščia = be prijungimo prie domeno',
      adUser: 'Prijungimo paskyra',
      adPassword: 'Prijungimo paskyros slaptažodis',
      adOu: 'Paskirties OU (neprivaloma)',
      advanced: 'Išplėstiniai: neapdoroti dokumentai',
      userData: 'user-data (neapdorota)',
      userDataHint: 'Pakeičia sugeneruotą user-data: naudotojas, slaptažodis, raktai ir Windows laukai aukščiau turi likti tušti',
      networkConfig: 'network-config (neapdorota)',
      networkConfigHint: 'Pakeičia sugeneruotą tinklą: IP, šliuzas ir DNS aukščiau turi likti tušti',
      secret: 'Laikyti neapdorotą user-data slapta',
      secretHint: 'Pažymėta slapta, API jos daugiau niekam negrąžina, o Checkpoint\'e ji keliauja užantspauduota masterpass',
      startNow: 'Paleisti iš karto',
      startNowHint: 'Kiekvienas egzempliorius paleidžiamas vos tik apibrėžtas; seed sukuriamas to paleidimo metu'
    },

    create: {
      nicAttachmentNetwork: 'Loginis tinklas (fabric)',
      nicNetwork: 'Loginis tinklas',
      nicNetworkHint: 'REKOMENDUOJAMAS kelias (F3): vNIC realizuojasi ant aptarnaujančio mazgo IŠVESTO tilto — tiltas gimsta per aiškų fabric apply, o paleidimas mazge, kuris jo dar neturi, atmeta kalbėdamas. Kai išeina paskutinė flotilės nuoroda, tiltas iškrenta per kitą apply.',
      button: 'Kurti VM',
      title: 'Kurti virtualiąją mašiną',
      dialogTitle: 'Kurti virtualiąją mašiną',
      stepGeneral: 'Bendra',
      stepGeneralHint: 'Pavadinimas ir profilis',
      stepCompute: 'CPU ir RAM',
      stepComputeHint: 'Topologija ir dydžiai',
      stepDisks: 'Diskai',
      stepDisksHint: 'Kurkite arba prijunkite',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Įrenginiai ir laikmenos',
      stepNetwork: 'Tinklas',
      stepNetworkHint: 'NIC: trunk arba bridge',
      stepSummary: 'Santrauka',
      stepSummaryHint: 'Patikrinkite ir sukurkite',
      name: 'Pavadinimas',
      nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai (DNS-1123)',
      nextButton: 'Toliau',
      prevButton: 'Atgal',
      submitButton: 'Kurti',
      creating: 'Kuriama…',
      sockets: 'Socket',
      cores: 'Branduolių viename socket',
      threads: 'Gijų viename branduolyje',
      totalVcpus: 'Iš viso vCPU',
      memoryGib: 'Atmintis (GiB)',
      cpuModelHint: '„host“ atveria hosto CPU',
      cpuLimitHint: 'Riba hosto branduoliais — tuščia = neribota',
      cpuNestedHint: "Atveria svečiui vmx/svm, kad jis galėtų vykdyti savo hipervizorių — reikalauja CPU modelio host ir mazgo su įjungtu nested",
      newDisk: 'Naujas diskas',
      attachDisk: 'Prijungti esamą diską',
      diskStorage: 'Storage',
      diskSize: 'Dydis (GiB)',
      diskSelect: 'Diskas',
      addDisk: 'Pridėti diską',
      addCdrom: 'Pridėti CD/DVD įrenginį',
      addNic: 'Pridėti tinklo sąsają',
      remove: 'Šalinti',
      slotLimit: 'Pasiekta slot riba',
      cdromImage: 'Atvaizdis (jei nenurodyta — tuščias įrenginys)',
      nicAttachment: 'Prijungimas',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Hosto bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Nėra (tik tagged)',
      nicTrunkHint: 'Bent viena pusė: untagged overlay ir (arba) tagged VLAN atvaizdavimai — VM gali veikti tik tuose hostuose, kuriuos deklaruoja kiekvienas nurodytas overlay',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay tinklas',
      addTagged: 'Pridėti tagged VLAN',
      nicBridge: 'Hosto bridge pavadinimas',
      nicBridgeHint: 'NM bridge pagal pavadinimą — VM gali veikti tik tuose serveriuose, kurių hosto tinklas deklaruoja šį bridge',
      nicMac: 'MAC (jei tuščia — automatiškai)',
      noDisksHint: 'Diskų nėra: VM turės tik tuos CD/DVD įrenginius, kuriuos pridėsite.',
      noCdromsHint: 'CD/DVD įrenginių nėra: pridėkite vieną, kad galėtumėte kilti iš ISO atvaizdžio.',
      mountGuestTools: 'Per pirmą paleidimą prijungti TVirt Guest Tools',
      mountGuestToolsHint: 'Įdeda ISO su virtio tvarkyklėmis ir guest agent į tuščią CD įrenginį (pridedamą, jei reikia) — Windows diegimo programai jo reikia, kad matytų diskus.',
      noNicsHint: 'Tinklo sąsajų nėra: VM pasileis be ryšio.',
      taggedMappings: 'Tagged VLAN atvaizdavimai',
      summaryDevices: 'Įrenginiai',
      bootOrderTitle: 'Įkrovos tvarka',
      bootOrderHint: 'Vilkite, kad pertvarkytumėte — laimi pirmas įkrovai tinkamas įrenginys; NIC kraunasi per PXE',
      bootOrderUp: 'Perkelti aukštyn',
      bootOrderDown: 'Perkelti žemyn',
      createError: 'Sukurti nepavyko'
    },
    edit: {
      button: 'Redaguoti',
      title: 'Redaguoti virtualiąją mašiną',
      cancel: 'Atšaukti',
      save: 'Įrašyti',
      error: 'Redaguoti nepavyko',
      modelStoppedOnly: 'Keičiama tik išjungus VM',
      firmwareStoppedOnly: 'Firmware keičiamas tik išjungus VM — kito paleidimo metu mašina startuoja su nauju firmware, o UEFI kintamieji lieka',
      hugePagesStoppedOnly: 'Keičiama tik išjungus VM — kito paleidimo metu atmintis gimsta ant naujo pagrindo',
      runningHint: 'Pakeitimai pritaikomi per kitą maitinimo ciklą',
      sectionCpu: 'CPU',
      sectionMemory: 'Atmintis',
      sectionPolicy: 'Politikos'
    },
    devices: {
      networkChip: 'fabric tinklas',
      title: 'Įrenginiai',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Pridėti USB įrenginį',
      addUsbTitle: 'Prašyti USB įrenginių klasės',
      usbClassHint:
        'VM prašo USB įrenginių KLASĖS (žymos usb-device reikšmės), niekada ne konkretaus įrenginio: paleidimo metu mazge parenkamas ir rezervuojamas konkretus laisvas įrenginys. Pažymėkite užregistruotus įrenginius skiltyje Klasteris › USB ir PCIe ištekliai.',
      usbTag: 'Žyma (usb-device)',
      usbValue: 'Klasės reikšmė',
      noUsbTags: 'Žymos usb-device nėra — sukurkite ją ir pažymėkite užregistruotus įrenginius skiltyje Klasteris › USB ir PCIe ištekliai.',
      noUsbValues: 'Ši žyma dar neturi deklaruotų reikšmių.',
      usbEmpty: 'USB reikalavimų nėra — pridėkite klasę, kad paleidimo metu būtų perduotas įrenginys.',
      usbClassChip: 'klasė',
      usbPortChip: 'prievadas',
      usbUnclaimed: 'Nerezervuotas nė vienas įrenginys — nustatoma paleidžiant VM.',
      addGpu: 'Pridėti GPU',
      addGpuTitle: 'Prašyti GPU klasės',
      gpuClassHint:
        'VM prašo GPU KLASĖS (žymos gpu-device reikšmės), niekada ne konkrečios plokštės: paleidimo metu mazge parenkama ir rezervuojama konkreti laisva plokštė, o KARTU perduodama visa jos IOMMU grupė. Pažymėkite užregistruotus GPU skiltyje Klasteris › USB ir PCIe ištekliai.',
      gpuTag: 'Žyma (gpu-device)',
      gpuValue: 'Klasės reikšmė',
      noGpuTags: 'Žymos gpu-device nėra — sukurkite ją ir pažymėkite užregistruotus GPU skiltyje Klasteris › USB ir PCIe ištekliai.',
      noGpuValues: 'Ši žyma dar neturi deklaruotų reikšmių.',
      gpuEmpty: 'GPU reikalavimų nėra — pridėkite klasę, kad paleidimo metu būtų perduota plokštė.',
      gpuClassChip: 'klasė',
      gpuGroupChip: 'IOMMU grupė ×',
      gpuUnclaimed: 'Nerezervuota nė viena plokštė — nustatoma paleidžiant VM.',
      gpuPowerCycle: 'Jokio GPU hotplug — pakeitimai galioja nuo kito maitinimo ciklo (PendingRestart)',
      actions: 'Veiksmai',
      attachDisk: 'Pridėti diską',
      attachDiskTitle: 'Pridėti diską',
      attach: 'Prijungti',
      noFreeDisks: 'Nenaudojamų diskų nėra — sukurkite vieną skiltyje Virtualiosios mašinos › Nenaudojami diskai.',
      addCdrom: 'Pridėti įrenginį',
      addCdromTitle: 'Pridėti CD/DVD įrenginį',
      editCdromTitle: 'Keisti CD/DVD atvaizdį',
      changeMedia: 'Keisti CD/DVD atvaizdį',
      ejectMedium: 'Išstumti',
      mountGuestTools: 'Prijungti TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools prijungtos',
      guestToolsClickMount: 'Įdeda TVirt Guest Tools ISO į pirmą tuščią CD/DVD įrenginį',
      guestToolsClickUnmount: 'Spustelėkite, kad išstumtumėte — įrenginys lieka, tuščias',
      guestToolsNoSlot: 'Tuščio CD/DVD įrenginio nėra — pridėkite įrenginį (arba išstumkite laikmeną), kad prijungtumėte TVirt Guest Tools',
      guestToolsSkew: 'Prijungta v{pinned}; mazgas {node} dabar teikia v{current}: išimkite ir prijunkite iš naujo, kad atnaujintumėte',
      ejectGuestTools: 'Išstumti TVirt Guest Tools (įrenginys lieka, tuščias)',
      guestToolsEjectConfirmTitle: 'Išstumti TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Laikmena išstumiama iš įjungtos VM — CD/DVD įrenginys lieka, tuščias.',
      applyLive: 'Taikyti iškart (VM įjungta)',
      addNic: 'Pridėti sąsają',
      addNicTitle: 'Pridėti tinklo sąsają',
      editNicTitle: 'Redaguoti tinklo sąsają',
      bridgeChip: 'bridge',
      cable: 'Virtualus kabelis',
      plug: 'Prijungti virtualų kabelį',
      unplug: 'Atjungti virtualų kabelį',
      remove: 'Šalinti',
      removeTitle: 'Šalinti {device}?',
      removeBody: 'Įjungtoje VM pakeitimas pritaikomas per kitą maitinimo ciklą. Diskai ir atvaizdžiai atjungiami, niekada neištrinami.'
    }
  }
}
